import React, { useState } from "react";
import { Siren, Heart } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import HelpOfferForm from "./HelpOfferForm";

const COPY = {
  rescue: {
    title: "Rescue organizations — contact us to help",
    desc: "Paws on Record is calling for help. Tell us how your organization can assist and our team will contact you directly.",
  },
  volunteer: {
    title: "Offer to help",
    desc: "Fosters, transport volunteers and individuals: tell us how you can help — foster, transport, supplies or volunteering.",
  },
};

// The two campaign call-to-action buttons, each opening its own form.
export default function CampaignHelpButtons({ rescue, disabled = false, testPrefix = "campaign" }) {
  const [open, setOpen] = useState(null);
  const c = open && COPY[open];
  return (
    <>
      <div className="flex flex-col gap-3" data-testid={`${testPrefix}-help-buttons`}>
        <button type="button" onClick={() => setOpen("rescue")} className="w-full bg-red-600 hover:bg-red-700 text-white font-black uppercase tracking-wide text-sm sm:text-base px-5 py-4 inline-flex items-center justify-center gap-2 transition-colors" data-testid={`${testPrefix}-rescue-org-btn`}>
          <Siren size={18} /> Rescue organizations — contact us to help
        </button>
        <button type="button" onClick={() => setOpen("volunteer")} className="w-full bg-white hover:bg-zinc-900 hover:text-white text-zinc-900 border-2 border-zinc-900 font-black uppercase tracking-wide text-sm sm:text-base px-5 py-4 inline-flex items-center justify-center gap-2 transition-colors" data-testid={`${testPrefix}-offer-help-btn`}>
          <Heart size={18} /> Offer to help
        </button>
        <p className="text-xs text-zinc-600 text-center" data-testid={`${testPrefix}-email-fallback`}>
          Prefer email? <a href={`mailto:info@pawsonrecord.com?subject=${encodeURIComponent(`${rescue.title} — rescue help`)}`} className="underline font-semibold">info@pawsonrecord.com</a>
        </p>
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto rounded-none" data-testid={`${testPrefix}-${open || "closed"}-dialog`}>
          {c && (
            <>
              <DialogHeader>
                <DialogTitle className="font-display font-black text-2xl uppercase tracking-tight">{c.title}</DialogTitle>
                <DialogDescription>{c.desc}<span className="block mt-1 font-semibold text-zinc-700">Campaign: {rescue.title}</span></DialogDescription>
              </DialogHeader>
              <HelpOfferForm key={open} rescueId={rescue.id} variant={open} disabled={disabled} />
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
